import { BrowserRouter, Routes, Router, Route } from "react-router-dom";
import Navbar from "./components/Navbar/NavbarDashboard";

import Progress from "./pages/progress";
import Profile from "./pages/profile";
import Page4 from "./pages/Page4";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { firebaseConfig } from "./firebase";

// Basic Pages
import Index from "./pages";
import Login from "./pages/Login"; //Removed
import Register from "./pages/register";
import Reset from "./pages/reset";
import Dashboard_1 from "./pages/dashboard";
import Dashboard_2 from "./pages/dashboard2";

// Fundamentals Page
import Fundamentals_Main from "./pages/lesson_pages/fundamentals/fundamentals_main";
import Fundamentals_1 from "./pages/lesson_pages/fundamentals/fundamentals_traffic_lights";
import ChangingLanes from "./pages/lesson_pages/fundamentals/fundamentals_changing_lanes";
import Overtaking from "./pages/lesson_pages/fundamentals/fundamentals_overtaking";

import Informative from "./pages/lesson_pages/ts_rm/ts_informative";

import TsRmPage from "./pages/lesson_pages/ts_rm/ts_rm_main";
import RoadSafetyPage from "./pages/lesson_pages/road_safety/road_safety_main";
import FinesPensVio from "./pages/lesson_pages/fpv/fpv_main";
import ResetEmail from "./pages/resetemail";
import QuizPage2 from "./pages/lesson_pages/fundamentals/fundamentals_red_light2";
import Braking from "./pages/lesson_pages/fundamentals/fundamentals_braking";
import Following from "./pages/lesson_pages/fundamentals/fundamentals_following";
import Speed from "./pages/lesson_pages/fundamentals/fundamentals_speed";
import Right from "./pages/lesson_pages/fundamentals/fundamentals_right";
import Traffic from "./pages/lesson_pages/ts_rm/ts_rm_main";
import Regulatory from "./pages/lesson_pages/ts_rm/ts_regulatory";
import Warning from "./pages/lesson_pages/ts_rm/ts_warning";
import About from "./pages/about";
import withSplashScreen from "./components/splash/withSplashScreen";
import Dashboard2 from "./pages/dashboard2";
import EditUsername from "./pages/editusername";
import ResetPassword from "./pages/resetpassword";
import Pretest from "./pages/pretest";
import Posttest from "./pages/posttest";
import WhiteLine from "./pages/lesson_pages/ts_rm/ts_whiteline";
import PavementArrow from "./pages/lesson_pages/ts_rm/ts_pavement";
import DoubleSolid from "./pages/lesson_pages/ts_rm/ts_double";
import CrossWalks from "./pages/lesson_pages/ts_rm/ts_crosswalks";
import RoadRage from "./pages/lesson_pages/road_safety/rs_roadrage";
import Defensive from "./pages/lesson_pages/road_safety/rs_defensive";
import Tips from "./pages/lesson_pages/road_safety/rs_tips";
import Licensing from "./pages/lesson_pages/fpv/fpv_licensing";
import Driving from "./pages/lesson_pages/fundamentals/fundamentals_driving";
import AlreadyTaken from "./components/taken/already_taken";
import Help from "./pages/help"

const App = () => {
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);
  return (
    <BrowserRouter>
      <Routes>
        {/* Basic Pages */}
        <Route exact path="/" element={<Index />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/reset" element={<Reset />} />
        <Route exact path="/dashboard" element={<Dashboard_1 />} />
        <Route exact path="/dashboard-page-2" element={<Dashboard_2 />} />

        {/* Fundamentals */}
        <Route exact path="/fundamentals" element={<Fundamentals_Main />} />
        <Route exact path="/fundamentals_1" element={<Fundamentals_1 />} />

        <Route exact path="/about" element={<About />} />
        <Route exact path="/progress" element={<Progress />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/page4" element={<Page4 />} />
        <Route exact path="/resetemail" element={<ResetEmail />} />
        <Route exact path="/fundamentals_red_light2" element={<QuizPage2 />} />
        <Route
          exact
          path="/fundamentals_changing_lanes"
          element={<ChangingLanes />}
        />
        <Route exact path="/fundamentals_overtaking" element={<Overtaking />} />
        <Route exact path="/fundamentals_driving" element={<Driving />} />

        <Route
          exact
          path="/traffic_signs_road_markings"
          element={<TsRmPage />}
        />

        <Route exact path="/rs_roadrage" element={<RoadRage />} />
        <Route exact path="/rs_defensive" element={<Defensive />} />
        <Route exact path="/rs_tips" element={<Tips />} />

        <Route exact path="/fpv_licensing" element={<Licensing />} />

        <Route exact path="/ts_whiteline" element={<WhiteLine />} />
        <Route exact path="/ts_pavement" element={<PavementArrow />} />
        <Route exact path="/ts_double" element={<DoubleSolid />} />
        <Route exact path="/ts_crosswalks" element={<CrossWalks />} />
        <Route exact path="/road_safety" element={<RoadSafetyPage />} />
        <Route exact path="/fundamentals_braking" element={<Braking />} />
        <Route exact path="/fundamentals_following" element={<Following />} />
        <Route exact path="/fundamentals_speed" element={<Speed />} />
        <Route exact path="/fundamentals_right" element={<Right />} />
        <Route exact path="/ts_rm_main" element={<Traffic />} />
        <Route exact path="/ts_regulatory" element={<Regulatory />} />
        <Route exact path="/ts_informative" element={<Informative />} />
        <Route exact path="/ts_warning" element={<Warning />} />
        <Route exact path="/fpv" element={<FinesPensVio />} />
        <Route exact path="/dashboard-page-2" element={<Dashboard2 />} />
        <Route exact path="/editusername" element={<EditUsername />} />
        <Route exact path="/pretest" element={<Pretest />} />
        <Route exact path="/posttest" element={<Posttest />} />
        <Route exact path="/resetpassword" element={<ResetPassword />} />
        <Route exact path="/already_taken" element={<AlreadyTaken />} />
        <Route exact path="/help" element={<Help />} />
      </Routes>
    </BrowserRouter>
  );
};

export default withSplashScreen(App);
